import { useState } from "react";
import { AiFillEyeInvisible, AiFillEye } from "react-icons/ai";

const EditPassword = ({ onConfirm, onCancel }) => {
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);

  return (
    <div className="w-screen h-screen flex flex-col items-center justify-center fixed top-0 left-0 right-0 z-[200] bg-gray-900/50 backdrop-blur-sm transition-opacity">
      <div className="relative flex flex-col justify-center bg-white shadow-lg rounded-lg font-body text-gray-900 text-center px-4 py-4"
      style={{ height: "225px", width: "500px" }}>
        <h2 className="text-2xl font-bold mb-4">Cambiar contraseña</h2>

        <div className="relative flex justify-center w-full">
          <input
            id="password"
            type={showPassword ? "text" : "password"}
            className="appearance-none xl:w-3/4 w-full my-2 px-4 py-2 rounded-full border border-gray-400 bg-white placeholder-gray-400 font-body text-xl focus:rounded-full focus:border-1 focus:bg-neutral-50 focus:border-clvblue"
            placeholder="Nueva contraseña"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />
          <button
            type="button"
            onClick={() => setShowPassword(!showPassword)}
            className="absolute inset-y-0 right-4 flex items-center text-gray-500 ml-2"
          >
            {showPassword ? (
              <AiFillEyeInvisible className="w-6 h-6" />
            ) : (
              <AiFillEye className="w-6 h-6" />
            )}
          </button>
        </div>

        <div className=" mt-4">
          <button
            onClick={onCancel}
            className="px-4 py-2 rounded-full bg-gray-300 text-gray-800 hover:bg-gray-400 border-2"
          >
            Cancelar
          </button>
          <button
            onClick={() => onConfirm(password)}
            className="px-4 py-2 ml-2 rounded-full bg-clvblue text-white hover:bg-blue-600"
          >
            Cambiar
          </button>
        </div>

        </div>
      </div>
  );
};

export default EditPassword;
